// Phase 6A — mobile-first Memorial landing hero.
// Accessible pet-navigation panel: a contained full-screen sheet, one
// per top-level Shopify Navigation menu item that has children (see
// sections/bpf-homepage-hero.liquid — section.settings.pet_navigation_
// menu drives which/how-many panels exist; this script never assumes
// "dog"/"cat" specifically, the trigger/panel pairing is just a plain
// opaque string match on data-bpf-homepage-hero-panel-trigger/-panel).
// Reuses this theme's own existing trapFocus()/removeTrapFocus()
// (assets/global.js, loaded sitewide before this deferred script —
// see this file's own header comment on load order) rather than a
// second/duplicate focus-trap implementation.
//
// Deliberately plain DOM APIs, no framework, matching every other
// small interactive piece in this theme (see assets/global.js itself).
// This section never resolves products or duplicates the Breed/Product/
// Full Builder resolver — every link here is a plain <a href> to
// wherever Shopify Navigation already points; this script only ever
// opens/closes the sheet and manages focus.
(function () {
  'use strict';

  function initBpfHomepageHeroPanels(root) {
    var triggers = root.querySelectorAll('[data-bpf-homepage-hero-panel-trigger]');
    if (!triggers.length) return;

    var lastTrigger = null;

    function getPanel(petType) {
      return root.querySelector('[data-bpf-homepage-hero-panel="' + petType + '"]');
    }

    function openPanel(petType, trigger) {
      var panel = getPanel(petType);
      if (!panel) return;
      lastTrigger = trigger;
      panel.hidden = false;
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var closeButton = panel.querySelector('[data-bpf-homepage-hero-panel-close]');
      trapFocus(panel, closeButton || panel);
    }

    function closePanel(panel) {
      if (!panel || panel.hidden) return;
      panel.hidden = true;
      document.body.style.overflow = '';
      var petType = panel.getAttribute('data-bpf-homepage-hero-panel');
      var trigger = root.querySelector('[data-bpf-homepage-hero-panel-trigger="' + petType + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      removeTrapFocus(lastTrigger || trigger);
      lastTrigger = null;
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openPanel(trigger.getAttribute('data-bpf-homepage-hero-panel-trigger'), trigger);
      });
    });

    root.querySelectorAll('[data-bpf-homepage-hero-panel]').forEach(function (panel) {
      panel.querySelectorAll('[data-bpf-homepage-hero-panel-close]').forEach(function (closeButton) {
        closeButton.addEventListener('click', function () {
          closePanel(panel);
        });
      });

      panel.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          closePanel(panel);
        }
      });
    });
  }

  var sections = document.querySelectorAll('[data-bpf-homepage-hero]');
  sections.forEach(function (section) {
    initBpfHomepageHeroPanels(section);
  });

  // Theme Editor section re-render safety: a fresh section instance
  // (new DOM node) after a settings/block edit needs its own listeners
  // bound again — never assumed to already have them.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-bpf-homepage-hero]');
    if (section) initBpfHomepageHeroPanels(section);
  });
})();
